/* @flow strict
 *
 * Builder for Protobuf Schema oneOfs generated by protobuf-gen-flow
 * generated from tinder/events/model/app/platform.proto
 */

import type {
  BinaryParseErrorEvent as Tinder_Events_Model_Common_BinaryParseErrorEvent,
  JsonParseErrorEvent as Tinder_Events_Model_Common_JsonParseErrorEvent
} from 'Lib/eventsSDK/events/tinder/events/model/common/error';
import type { DiskMeasure as Tinder_Events_Model_App_Metrics_DiskMeasure } from 'Lib/eventsSDK/events/tinder/events/model/app/metrics/disk_measure';
import type { DurationMeasure as Tinder_Events_Model_App_Performance_DurationMeasure } from 'Lib/eventsSDK/events/tinder/events/model/app/performance/duration_measure';
import type { HubbleInstrument as Tinder_Events_Model_App_Hubble_HubbleInstrument } from 'Lib/eventsSDK/events/tinder/events/model/app/hubble/hubble';
import type { JsonEvent as Tinder_Events_Model_Common_JsonEvent } from 'Lib/eventsSDK/events/tinder/events/model/common/json';
import type { LogEvent as Tinder_Events_Model_Common_LogEvent } from 'Lib/eventsSDK/events/tinder/events/model/common/log';
import type { NetworkPerf as Tinder_Events_Model_App_Network_NetworkPerf } from 'Lib/eventsSDK/events/tinder/events/model/app/network/network_perf';
import type { SdkPerf as Tinder_Events_Model_App_Metrics_SdkPerf } from 'Lib/eventsSDK/events/tinder/events/model/app/metrics/sdk_perf';
import type { TestEvent1 } from 'Lib/eventsSDK/events/tinder/events/model/app/test';
import type { AppPlatformEvent } from 'Lib/eventsSDK/events/tinder/events/model/app/platform';
export const APP_PLATFORM_EVENT_NETWORK_PERF: 'networkPerf' = 'networkPerf'; // tinder.events.model.app.network.NetworkPerf
export const APP_PLATFORM_EVENT_BINARY_PARSE_ERROR_EVENT: 'binaryParseErrorEvent' = 'binaryParseErrorEvent'; // tinder.events.model.common.BinaryParseErrorEvent
export const APP_PLATFORM_EVENT_JSON_PARSE_ERROR_EVENT: 'jsonParseErrorEvent' = 'jsonParseErrorEvent'; // tinder.events.model.common.JsonParseErrorEvent
export const APP_PLATFORM_EVENT_LOG_EVENT: 'logEvent' = 'logEvent'; // tinder.events.model.common.LogEvent
export const APP_PLATFORM_EVENT_DURATION_MEASURE: 'durationMeasure' = 'durationMeasure'; // tinder.events.model.app.performance.DurationMeasure
export const APP_PLATFORM_EVENT_JSON_EVENT: 'jsonEvent' = 'jsonEvent'; // tinder.events.model.common.JsonEvent
export const APP_PLATFORM_EVENT_HUBBLE_INSTRUMENT: 'hubbleInstrument' = 'hubbleInstrument'; // tinder.events.model.app.hubble.HubbleInstrument
export const APP_PLATFORM_EVENT_SDK_PERF: 'sdkPerf' = 'sdkPerf'; // tinder.events.model.app.metrics.SdkPerf
export const APP_PLATFORM_EVENT_DISK_MEASURE: 'diskMeasure' = 'diskMeasure'; // tinder.events.model.app.metrics.DiskMeasure
export const APP_PLATFORM_EVENT_TEST_EVENT_1: 'testEvent1' = 'testEvent1'; // TestEvent1

export type OneOfAppPlatformEventValue = {| schema: typeof APP_PLATFORM_EVENT_BINARY_PARSE_ERROR_EVENT, ...Tinder_Events_Model_Common_BinaryParseErrorEvent |} |
{| schema: typeof APP_PLATFORM_EVENT_DISK_MEASURE, ...Tinder_Events_Model_App_Metrics_DiskMeasure |} |
{| schema: typeof APP_PLATFORM_EVENT_DURATION_MEASURE, ...Tinder_Events_Model_App_Performance_DurationMeasure |} |
{| schema: typeof APP_PLATFORM_EVENT_HUBBLE_INSTRUMENT, ...Tinder_Events_Model_App_Hubble_HubbleInstrument |} |
{| schema: typeof APP_PLATFORM_EVENT_JSON_EVENT, ...Tinder_Events_Model_Common_JsonEvent |} |
{| schema: typeof APP_PLATFORM_EVENT_JSON_PARSE_ERROR_EVENT, ...Tinder_Events_Model_Common_JsonParseErrorEvent |} |
{| schema: typeof APP_PLATFORM_EVENT_LOG_EVENT, ...Tinder_Events_Model_Common_LogEvent |} |
{| schema: typeof APP_PLATFORM_EVENT_NETWORK_PERF, ...Tinder_Events_Model_App_Network_NetworkPerf |} |
{| schema: typeof APP_PLATFORM_EVENT_SDK_PERF, ...Tinder_Events_Model_App_Metrics_SdkPerf |} |
{| schema: typeof APP_PLATFORM_EVENT_TEST_EVENT_1, ...TestEvent1 |};

/**
 * Builds Protobuf Message tinder.events.model.app.AppPlatformEvent.
 * Generated by Protobuf-gen-flow.
 * @param {Object} data
 * @return {AppPlatformEvent}
 */

export function appPlatformEventBuilder({
  oneOfvalue = {}
}: {
  oneOfvalue?: OneOfAppPlatformEventValue
}): AppPlatformEvent {
  // $FlowFixMe - creating an empty object for an exact class
  const result: AppPlatformEvent = {};

  const { schema: value, ...valueData } = oneOfvalue;
  if (value !== undefined) {
    // $FlowFixMe - some versions of flow do not compute oneOf fields properly
    result[value] = valueData;
  }

  return result;
}

